import { render } from "./HandleLogin.vue?vue&type=template&id=36016d52&ts=true"
import script from "./HandleLogin.vue?vue&type=script&lang=ts"
export * from "./HandleLogin.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/HandleLogin.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36016d52"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36016d52', __exports__)) {
    api.reload('36016d52', __exports__)
  }
  
  module.hot.accept("./HandleLogin.vue?vue&type=template&id=36016d52&ts=true", () => {
    api.rerender('36016d52', render)
  })

}


export default __exports__